<template>
    <div>
      <b-container fluid>
        <b-row>
          <b-col>
            <h3>{{ data.name ? 'Editar Nome do Relatório' : 'Definir Nome do Relatório' }}</h3>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" class="mt-2 mb-3">
            <b-form-group
              label="Nome do Relatório"
              description="Exemplo: Relatório do Rodeio de Lavras 2025"
              label-for="report-name-input"
            >
              <b-form-input
                id="report-name-input"
                v-model="localData.name"
              ></b-form-input>
            </b-form-group>
            </b-col>

            <b-col cols="12" class="text-right">
            <b-button @click="emitData" class="mr-1" variant="success" :disabled="!localData.name">
              <icon name="arrow-right" scale="1" class="mr-2"></icon> Avançar
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </template>

  <script>
  export default {
    props: {
      // Determina se é edição ou criação
      isEdit: {
        type: Boolean,
        default: false,
      },
      data: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        localData: {
          name: this.data.name || '', // Inicializa com o nome existente (edição) ou vazio (criação)
        },
      };
    },
    methods: {
      emitData() {
        this.$emit('update-data', this.localData);
        this.$emit('next'); // Avança para a próxima etapa
      },
    },
  };
  </script>
